import { useDisclosure, useToast } from '@chakra-ui/react'
import DoppelPrimaryButton from '../doppel_design/doppel_primary_button'
import BulkExternallyAssignAlertsModal from '../alerts/bulk_externally_assign_alerts_modal'
import { useIsEmployeeView } from '@/hooks/id_token_claims'

type BulkExternallyAssignButtonProps = {
  selectedRows: any[]
  refreshFunc: () => void
}

const BulkExternallyAssignButton = ({
  selectedRows,
  refreshFunc,
}: BulkExternallyAssignButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useToast()
  const [isEmployeeView] = useIsEmployeeView()

  const handleClick = () => {
    // Validate that all selected alerts belong to the same organization
    if (selectedRows && selectedRows.length > 0) {
      const firstOrgId = selectedRows[0].original.organization?.id
      const allSameOrg = selectedRows.every(
        (row) => row.original.organization?.id === firstOrgId,
      )

      if (!allSameOrg) {
        toast({
          title: 'Error',
          description: 'All selected alerts must belong to the same organization',
          status: 'error',
          isClosable: true,
        })
        return
      }

      if (!firstOrgId) {
        toast({
          title: 'Error',
          description: 'Selected alerts must have a valid organization',
          status: 'error',
          isClosable: true,
        })
        return
      }
    }

    onOpen()
  }

  return (
    <>
      <DoppelPrimaryButton fontSize="11" h="30px" onClick={handleClick}>
        {isEmployeeView ? 'Bulk Externally Assign Alerts' : 'Bulk Assign Alerts'}
      </DoppelPrimaryButton>

      <BulkExternallyAssignAlertsModal
        isOpen={isOpen}
        onClose={onClose}
        refreshFunc={refreshFunc}
        selectedRows={selectedRows}
      />
    </>
  )
}

export default BulkExternallyAssignButton
